'use strict';

function MortgageSubmitted() {
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MortgageController];
  this.centeredElement = null;

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    this.analytics.pushEvent('virtual-page-view');
    this.pushAnalyticsMortgageChoices();
    this.pushAnalyticsMortgageInfo();
  };

  this.destroy = function () {
    this._super();
  };

  this._hasCoApplicant = function () {
    return this.presenter.models.mortgage.has_supporter === 1;
  };
}